import { ContentsUnion } from '@elearning-platform/api-types/interfaces';
import { ContentFilter, ContentFilterType } from '@elearning-platform/ui';

import { LessonStatus } from '../../enums';

import { CategoryFilter, FilterableAttributeValue, FilterName } from './enums';
import { FilterableAttribute } from './interfaces';

export const filterableAttributes: FilterableAttribute[] = [
  {
    value: FilterableAttributeValue.Required,
    label: 'competence.app.knowledgeBaseV2.filters.required',
    matches: (item: ContentsUnion): boolean => 'required' in item && item.required,
  },
  {
    value: FilterableAttributeValue.Cyclical,
    label: 'competence.app.knowledgeBaseV2.filters.cyclical',
    matches: (item: ContentsUnion): boolean => 'cyclical' in item && item.cyclical,
  },
];

export const filters: ContentFilter[] = [
  {
    name: FilterName.Status,
    label: 'competence.app.knowledgeBaseV2.filters.status',
    type: ContentFilterType.Multiselect,
    options: [
      { value: LessonStatus.NotStarted, label: 'competence.app.knowledgeBaseV2.filters.notStarted' },
      { value: LessonStatus.InProgress, label: 'competence.app.knowledgeBaseV2.filters.inProgress' },
      { value: LessonStatus.Finished, label: 'competence.app.knowledgeBaseV2.filters.finished' },
      { value: LessonStatus.Failed, label: 'competence.app.knowledgeBaseV2.filters.failed' },
    ],
  },
  {
    name: FilterName.Attributes,
    label: 'competence.app.knowledgeBaseV2.filters.attributes',
    type: ContentFilterType.Multiselect,
    options: filterableAttributes,
  },
  {
    name: FilterName.Type,
    label: 'competence.app.knowledgeBaseV2.filters.type',
    type: ContentFilterType.Multiselect,
    options: [
      { value: CategoryFilter.ELearning, label: 'competence.app.knowledgeBaseV2.filters.eLearning' },
      { value: CategoryFilter.Video, label: 'competence.app.knowledgeBaseV2.filters.video' },
      { value: CategoryFilter.Files, label: 'competence.app.knowledgeBaseV2.filters.documents' },
      { value: 'favorite', label: 'competence.app.knowledgeBaseV2.filters.favorite' },
    ],
  },
];
